@for (category of parentCategories; track category) {
  <!-- display sub categories -->
  @if (category.isVisible ) {
    <button  (click)="selectCategory(category.id!); $event.stopPropagation()"
      [queryParams]="{inStock:true}"[autofocus]="true"  matRipple class="category"
      [class.selected]="selectedCategoryId === category.id"
      routerLink="/products/category/{{ category.id }}/{{ category.label }}">
      <span >{{ category.label }} </span>
      <img (click)="selectCategory(category.id!); $event.stopPropagation()"
         [src]="selectedCategoryId === category.id
          ? 'assets/icons/remove-white.svg'
          : 'assets/icons/add.svg'" alt="" />
    </button>
  } @else {
    <button   (click)="onClose.emit(false)" [autofocus]="true"  matRipple class="category" [class.selected]="true"    [queryParams]="{inStock:true}" routerLink="/products/category/{{ category.id }}/{{ category.label }}">
      <span >{{ category.label }} </span>
    </button>
  }
  <!-- hide sub categories -->
  <!-- sub categories list -->
  <div class="subcategories" [@expansion]="selectedCategoryId === category.id ? 'expanded' : 'collapsed'">
    @for (subcategory of subCategories(category.id!); track subcategory) {
      <button matRipple class="category" (click)="selectSubCategory(subcategory.id!); $event.stopPropagation()"
        [class.selected2]="selectedsubCategoryId === subcategory.id"
        [queryParams]="{inStock:true}"
        routerLink="/products/category/{{ category.id }}/{{ category.label }}/{{subcategory.id}}/{{subcategory.label}}"
        >
        <span >{{ subcategory.label }}</span>
        <img (click)="selectSubCategory(subcategory.id!); $event.stopPropagation()"
             [src]="selectedsubCategoryId === subcategory.id
             ? 'assets/icons/remove-white.svg'
             : 'assets/icons/add-24px-2.svg'" alt=""
          />
      </button>
      <div class="subsubcategories" [@expansion]="selectedsubCategoryId === subcategory.id ? 'expanded' : 'collapsed'">
        @for (subSubCategory of subCategories(subcategory.id!); track subSubCategory) {
          <button  (click)="onClose.emit(false)" [disabled]="subSubCategory.numberOfProducts==0"   matRipple
            routerLink="/products/category/{{ category.id }}/{{ category.label }}/{{subcategory.id}}/{{subcategory.label}}"
            [queryParams]="{ categories: subSubCategory.id,inStock:true }">
            <span    [ngClass]="{'cat-item-disabled':subSubCategory.numberOfProducts==0 }">{{ subSubCategory.label }}</span>
          </button>
        }
      </div>
    }
  </div>
}
